export enum RsvpStatus {
  NONE = "None",
  PENDING = "Pending",
  ATTENDING = "Accepted",
  MAYBE = "Maybe",
  NOT_ATTENDING = "Declined",
  NO_RESPONSE = "NoResponse",
}

export interface IRsvpAdditionalGuest {
  eventGuestId?: number
  name?: string
  email?: string
  dietaryRequirements?: string
  songRequests?: string
  rsvpStatus: RsvpStatus
}

export interface IRsvpResponse {
  eventGuestId?: number
  name?: string
  email?: string
  additionalGuests?: IRsvpAdditionalGuest[]
  rsvpDetails?: {
    rsvpStatus?: RsvpStatus
    guestRSVPComment?: string
    dietaryRequirements?: string
    songRequests?: string
    guestCount?: number
    rsvpUpdatedDate?: Date
  }
}

export class RsvpResponse {
  public eventGuestId?: number
  public name?: string
  public email?: string
  public additionalGuests?: IRsvpAdditionalGuest[]
  public rsvpDetails?: {
    rsvpStatus?: RsvpStatus
    guestRSVPComment?: string
    dietaryRequirements?: string
    songRequests?: string
    guestCount?: number
    rsvpUpdatedDate?: Date
  }

  constructor(rsvpResponse: Partial<RsvpResponse>) {
    this.eventGuestId = rsvpResponse.eventGuestId
    this.name = rsvpResponse.name
    this.email = rsvpResponse.email
    this.additionalGuests = rsvpResponse.additionalGuests
    this.rsvpDetails = rsvpResponse.rsvpDetails
  }

  public static fromResponse(response?: IRsvpResponse) {
    return new RsvpResponse({
      eventGuestId: response?.eventGuestId,
      name: response?.name,
      email: response?.email,
      additionalGuests: response?.additionalGuests,
      rsvpDetails: response?.rsvpDetails,
    })
  }
}
